import { render, staticRenderFns } from "./BreakdownPopup.vue?vue&type=template&id=7a15466e&scoped=true"
import script from "./BreakdownPopup.vue?vue&type=script&lang=js"
export * from "./BreakdownPopup.vue?vue&type=script&lang=js"
import style0 from "./BreakdownPopup.vue?vue&type=style&index=0&id=7a15466e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15466e",
  null
  
)

export default component.exports